import merge from 'lodash/merge';
/* eslint-disable import/no-duplicates */
import localTheme from '@generic/config/theme/theme';
import baseTheme from '../config/theme/theme';
/* eslint-enable import/no-duplicates */

export default merge({}, baseTheme, localTheme);
